import React, { createContext, useContext, useState, useCallback } from 'react';

const PhotoRefreshContext = createContext();

export const usePhotoRefresh = () => {
  const context = useContext(PhotoRefreshContext);
  if (!context) {
    throw new Error('usePhotoRefresh must be used within a PhotoRefreshProvider');
  }
  return context;
};

export const PhotoRefreshProvider = ({ children }) => {
  // Map of emp_id to photo_updated_at timestamp
  const [photoTimestamps, setPhotoTimestamps] = useState({});

  // Trigger a refresh for a specific employee's photo
  const refreshEmployeePhoto = useCallback((empId) => {
    setPhotoTimestamps(prev => ({
      ...prev,
      [empId]: Date.now()
    }));
  }, []);

  // Get the current timestamp for an employee's photo
  const getPhotoTimestamp = useCallback((empId) => {
    return photoTimestamps[empId] || null;
  }, [photoTimestamps]);

  const value = {
    refreshEmployeePhoto,
    getPhotoTimestamp,
    photoTimestamps
  };

  return (
    <PhotoRefreshContext.Provider value={value}>
      {children}
    </PhotoRefreshContext.Provider>
  );
};
